import { BANK, COURSE_WIDTH } from "./constants";
import { playerScreenFrac, type GameSim } from "./sim";

function noise1(n: number): number {
  const x = Math.sin(n * 127.1) * 43758.5453;
  return x - Math.floor(x);
}

export type ViewCamera = {
  scale: number;
  frac: number;
  camX: number;
  camY: number;
  viewWorldH: number;
  ox: number;
  oy: number;
  viewW: number;
  viewH: number;
};

export function computeView(sim: GameSim, viewW: number, viewH: number): ViewCamera {
  const p = sim.player;
  const worldW = COURSE_WIDTH + BANK * 2;
  let scale = viewW / worldW;
  const frac = playerScreenFrac(sim);
  let viewWorldH = viewH / scale;
  const look = viewWorldH * (1 - frac);
  if (look < 620) {
    scale = viewH / (620 / (1 - frac));
    viewWorldH = viewH / scale;
  }

  const camX = COURSE_WIDTH / 2;
  const camY = p.y - frac * viewWorldH;
  sim.camX = camX;
  sim.camY = camY;

  const shake = sim.trauma * sim.trauma;
  const ox = sim.reducedMotion ? 0 : (noise1(sim.clock * 37) - 0.5) * 18 * shake;
  const oy = sim.reducedMotion ? 0 : (noise1(sim.clock * 41 + 2) - 0.5) * 14 * shake;

  return { scale, frac, camX, camY, viewWorldH, ox, oy, viewW, viewH };
}

export function toScreenX(worldX: number, cam: ViewCamera): number {
  return (worldX - cam.camX) * cam.scale + cam.viewW / 2;
}

export function toScreenY(worldY: number, cam: ViewCamera): number {
  return (worldY - cam.camY) * cam.scale;
}
